module.exports = __webpack_public_path__ + "assets/img/gar5-7.3371240a.jpg";